import React from "react";
import Reveal from "./Reveal";

const stats = [
  { num: "15,000+", label: "Scholars Guided" },
  { num: "500+", label: "Expert Consultants" },
  { num: "4.9★", label: "Google Rating" },
  { num: "95%", label: "Submission Success Rate" },
];

export default function StatsBand() {
  return (
    <section className="stats-band">
      <div className="wrap">
        <div className="stats-grid">
          {stats.map((s) => (
            <Reveal as="div" key={s.label}>
              <div className="num">{s.num}</div>
              <div className="lab">{s.label}</div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
